import React, { useEffect, useState } from 'react';
import { Hand, Apple, Shield, Gift } from 'lucide-react';
interface FeaturesSectionProps {
  onNavigateToCheckout?: () => void;
}
export function FeaturesSection({
  onNavigateToCheckout
}: FeaturesSectionProps) {
  const [scrollY, setScrollY] = useState(0);
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
      // Show button only after scrolling past the banner (approximately 700px)
      setShowButton(window.scrollY > 700);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleButtonClick = () => {
    // Navigate to checkout page
    if (onNavigateToCheckout) {
      onNavigateToCheckout();
      // Scroll to top of the page after navigation
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  };
  const features = [{
    icon: Hand,
    title: 'One-Touch Automatic Peeling',
    bgColor: 'bg-gray-200',
    textColor: 'text-black'
  }, {
    icon: Apple,
    title: 'Works on Apples, Pears, Potatoes & More',
    bgColor: 'bg-blue-900',
    textColor: 'text-white'
  }, {
    icon: Shield,
    title: 'Hands-Free, Safe & Efficient',
    bgColor: 'bg-gray-200',
    textColor: 'text-black'
  }, {
    icon: Gift,
    title: 'Perfect for Home Cooking & Parties',
    bgColor: 'bg-blue-900',
    textColor: 'text-white'
  }];
  return <div className="w-full max-w-[1400px] mt-8 px-4" data-id="element-271">
      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-272">
        {features.map((feature, index) => <div key={index} className={`${feature.bgColor} ${feature.textColor} rounded-2xl p-6 flex flex-col items-start gap-3`} data-id="element-273">
            <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center" data-id="element-274">
              <feature.icon className="w-6 h-6 text-white" data-id="element-275" />
            </div>
            <h3 className="font-bold text-lg leading-tight" data-id="element-276">{feature.title}</h3>
          </div>)}
      </div>

      {/* Floating CTA Button that follows scroll - only visible after banner */}
      {showButton && <div className="flex justify-center relative" data-id="element-277">
          <div className="fixed left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ease-out" style={{
        top: `${Math.min((scrollY - 700) * 0.5 + 100, window.innerHeight - 150)}px`,
        opacity: showButton ? 1 : 0
      }} data-id="element-278">
            <button onClick={handleButtonClick} className="bg-blue-900 text-white px-6 md:px-12 py-2.5 md:py-4 rounded-lg md:rounded-full font-bold text-sm md:text-xl flex items-center gap-2 md:gap-3 hover:bg-blue-800 transition-colors shadow-2xl animate-pulse-slow" data-id="element-279">
              BUY NOW 50% OFF
              <svg className="w-4 h-4 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-280">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-281" />
              </svg>
            </button>
          </div>
        </div>}
    </div>;
}